export default "__VITE_ASSET__BeqsIqV3__"